module.exports = __webpack_public_path__ + "img/1239.73d1f7bd.gif";